import React, {useEffect, useMemo, useRef, useState} from 'react';
import Page from "../../../_layout/Page";
import {useHistory, useParams} from "react-router-dom";
import BackBtn from "../../../UI/BackBtn";
import {Button, Card, Col, Row,Form} from "react-bootstrap";
import style from './TabResults.module.less'
import {observer} from "mobx-react";
import {useStore} from "../../../../stores/StoreHelpers";
import useAPI from "../../../../hooks/useAPI";
import {Spinner} from "react-bootstrap";
import Required from "../../../Required";
import AsyncSelect from "react-select/async";
import api from "../../../../api";
import {makeUID} from "../../../../helpers";
import {ResultCardForm} from "./ResultCardForm";
import {toJS} from "mobx";
import useToast from "../../../../hooks/useToast";
import {StrategyRequests} from "../../../../requests/StrategyRequests/strategyRequests";
import useUserContext from "../../../../hooks/useUserContext";
import HintCard from "../../../common/HintCard/HintCard";
import {useRequestObject} from "../../../../hooks/useRequestObject";
import {isAdmin, isStratAdmin} from "../../../../services/rolesSvc";



const StratResultSubView = observer(() => {

    const {stratId} = useParams();
    const store = useStore()
    const history = useHistory()
    const api = useAPI()
    const addToast = useToast();
    const [validated,setValidated] = useState(false)
    const formEl = useRef(null);
    const requestObject = useRequestObject({classType:StrategyRequests, stratId, api, addToast, store})
    const refScroll = useRef(null)
    const refEndScroll = useRef(null)
    const userCtx = useUserContext();


    // useEffect(()=>{
    //     if(store.strategies.planResults.length === 0) {
    //         const fetchResult = async () => {
    //             return await api.get(`/strategies/${stratId}/results?full=true`)
    //         }
    //         fetchResult()
    //             .then(x => {
    //                 store.strategies.setPlanResults(x)
    //             })
    //             .catch(() => addToast.error('Не удалось загрузить данные.'))
    //     }
    // },[])

    const [strategy, setStrategy] = useState({})
    const [projects, setProjects] = useState([])
    const [closedPeriods, setClosedPeriods] = useState([])

    useEffect(()=>{
        const getStrategy = async() => api.get(`/mng/strategies/${stratId}`)
        const getProjects = async() => api.get(`/projs?short=true&strategyId=${stratId}`)
        const getClosedPeriods = async() => api.get('/reports/periods/results')
        getStrategy()
            .then(strategy => setStrategy(strategy))
        getProjects()
            .then(projects => setProjects(projects.filter(proj => proj.status !== 'closed').sort((a, b) => a.fullNumber.length - b.fullNumber.length || +a.fullNumber - +b.fullNumber)))
            .catch(() => addToast.error('Не удалось загрузить данные'))
        getClosedPeriods()
          .then(periods => setClosedPeriods(periods
            .filter(period => period.isClosed)
            .map(period => period.year)
          ))
        if(store.strategies.planResults.length === 0) {
            const fetchResult = async () => {
                return await api.get(`/strategies/${stratId}/results?full=true`)
            }
            fetchResult()
                .then(x => {
                    store.strategies.setPlanResults(x.filter((v) => !v.parentId).map(res => {
                    if(res.milestones){
                        res.milestones = res.milestones.map(milestone => ({...milestone, projs: milestone.projs ? milestone.projs.map(proj => ({...proj, id: proj.originId})) : []}))
                    }
                    return {...res, projs: res.projs ? res.projs.map(proj => ({...proj, id: proj.originId})) : []}
                    }))
                    if(store.strategies.planResults.length === 0) {
                        store.strategies.addPlanResults(stratId)
                    }
                })
                .catch(() => addToast.error('Не удалось загрузить данные.'))
        }
        if (store.strategies.trls.length === 0) {
            requestObject.handleAddResult().catch()
        }
    },[])

    const scrollToStart = () => {
        window.scrollTo(0, refScroll.current.scrollHeight)
    }

    const scrollToEnd = () => {
        window.scrollTo(0, refEndScroll.current.offsetTop-1300)
    }

    const addPlanButton = (isInCard=false) => {
        {
            return !isInCard ?
                <Col style={{marginBottom:`1.2rem`}}>
                    <Button className={style.resultAddPlanButton} onClick={()=>requestObject.promiseAddPlanResult().then(()=>scrollToEnd())}>
                        + Добавить план результата
                    </Button>
                </Col>
                : <Button className={style.resultAddPlanButton} onClick={()=>requestObject.promiseAddPlanResult().then(()=>scrollToEnd())}>
                    + Добавить план результата
                </Button>
        }
    }

    const headerResult = (

        <div ref={refScroll}>
            <HintCard text={"Укажите планируемые результаты и вехи стратегического проекта"}/>
        </div>
    )
    const saveButton = (
        <Row className={style.stickyButtons}>
            <Col>
                <Card>
                    <Card.Body>
                        {addPlanButton(true)}
                        <Button type="submit" className={style.resultAddPlanButton} disabled={store.strategies.isLoading} variant={'outline-primary'}>Сохранить</Button>
                        <Button type={"button"}
                                style={{color:'#0D6EFD'}}
                                onClick = {()=>{
                                    store.strategies.clearNoSavedPlanResults();
                                    history.push(`/strats/${stratId}/?t=results`)
                                }}
                                variant='light'>Перейти в реестр</Button>
                    </Card.Body>
                </Card>
            </Col>
    </Row>)

    const content = (store.strategies.fetchStatus ?
        <>
            {headerResult}
            <Form
                noValidate
                validated={validated}
                onSubmit={(event) => requestObject.handleSubmitForm(event,formEl,()=>requestObject.savePlanResults().then(scrollToStart),(flag)=>setValidated(flag),false)}
                ref={formEl}>
                {store.strategies.planResults.filter(result => !result.yearPlan || result.yearPlan >= 2023).map((x,y) => <ResultCardForm
                    key={x?.id || x?.key}
                    index= {y}
                    value = {{...x, milestones: x.milestones || []}}
                    options={{ygt:store.strategies.trls,getOptions:requestObject.getOptions,stratId}}
                    onChange={(...e) => requestObject.updatePlanResults(e)}
                    userCtx={userCtx}
                    onDelete = {()=>requestObject.deletePlan(x)}
                    onDeleteFile={(fileId,planId)=>requestObject.deleteFile(fileId,planId)}
                    projects={projects}
                    closedPeriods={closedPeriods}
                />)
                }
                <div ref={refEndScroll}></div>
                {saveButton}
            </Form>
        </>:
            <>
                <Spinner animation={"border"} style={{ width: "4rem", height: "4rem" }}>
                    <span className={"visually-hidden"}>Loading...</span>
                </Spinner>
            </>
    )
    return (
        <Page styleSection={{backgroundColor:'#F5F5FF'}} className="projects-page">
            <Row>
                <Col sm={'2'}>
                    <BackBtn onClick = {()=>{
                        store.strategies.clearNoSavedPlanResults()
                        history.goBack()
                    }}/>
                </Col>
            </Row>
            {strategy.id && <Row>
                <Col className={style.headerProject}>
                    {`Выдающиеся результаты ${strategy.num} `}
                </Col>
            </Row>}
            {(isAdmin(userCtx) || isStratAdmin(userCtx, stratId)) &&  content}
        </Page>
    );
});
export default StratResultSubView;




